import type { Company } from "../../types";

/** Avant APPLY API, is_owner peut manquer : on n’bloque pas le propriétaire. */
export function isCompanyOwner(company: Company | null): boolean {
  return company == null || company.is_owner !== false;
}
